import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "users"
}
const _hoisted_2 = { class: "users-grid" }
const _hoisted_3 = ["onClick", "title"]
const _hoisted_4 = { class: "username" }

import { reactive, ref, toRefs } from "vue";
import User from "@/mode/User";
import Avatar from "@/components/Avatar.vue";
import showUser from "@/components/user-modal";
import { useRoute } from "vue-router";
import DeptApi from "@/api/DeptApi";


export default /*@__PURE__*/_defineComponent({
  __name: 'DeptInfo',
  setup(__props) {

const route = useRoute();
const loading = ref(true);
const data = reactive({
  users: new Array<User>(),
});
const deptId = route.params.id;

if (typeof deptId === "string") {
  loading.value = true;
  DeptApi.users(deptId)
    .then((res) => {
      res.data.forEach((item: User) => {
        data.users.push(item);
      });
    })
    .finally(() => {
      loading.value = false;
    });
}

const { users } = toRefs(data);

return (_ctx: any,_cache: any) => {
  const _component_el_result = _resolveComponent("el-result")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_main = _resolveComponent("el-main")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_main, { class: "dept-box" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_scrollbar, { height: "100%" }, {
        default: _withCtx(() => [
          (_unref(users).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(users), (user) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: user.id,
                      class: "user",
                      onClick: ($event: any) => (_unref(showUser)(user.id, true)),
                      title: user.name
                    }, [
                      _createVNode(Avatar, {
                        img: user.avatar,
                        name: user.name
                      }, null, 8, ["img", "name"]),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(user.name), 1)
                    ], 8, _hoisted_3))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(users).length === 0)
            ? (_openBlock(), _createBlock(_component_el_result, {
                key: 1,
                icon: "info"
              }, {
                "sub-title": _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("p", null, "此部门暂时没有用户哦！", -1)
                ])),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  })), [
    [_directive_loading, loading.value]
  ])
}
}

})